var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0072 2.53669C9.72262 1.82019 10.883 1.81975 11.5989 2.53571L13.2602 4.19694C13.97 4.9068 13.9774 6.05597 13.2767 6.77488L7.12129 13.0904C6.65093 13.573 6.00583 13.8451 5.33221 13.8451L3.49744 13.845C2.64461 13.8449 1.96353 13.134 1.9994 12.2813L2.07817 10.4086C2.1045 9.78259 2.36469 9.18926 2.80725 8.74604L9.0072 2.53669ZM10.8924 3.24335C10.5669 2.91791 10.0395 2.91811 9.71431 3.2438L8.60575 4.35403L11.4589 7.20722L12.5611 6.07638C12.8796 5.7496 12.8763 5.22724 12.5536 4.90458L10.8924 3.24335ZM3.51435 9.45314L7.89918 5.06168L10.7609 7.92341L6.4057 12.3919C6.12349 12.6814 5.73642 12.8447 5.33225 12.8447L3.49749 12.8446C3.21321 12.8446 2.98618 12.6076 2.99814 12.3234L3.07691 10.4507C3.09271 10.0751 3.24882 9.71908 3.51435 9.45314ZM13.6768 13.7971C13.9528 13.7971 14.1766 13.5732 14.1766 13.2969C14.1766 13.0207 13.9528 12.7967 13.6768 12.7967H9.59562C9.31958 12.7967 9.09581 13.0207 9.09581 13.2969C9.09581 13.5732 9.31958 13.7971 9.59562 13.7971H13.6768Z",
    fill: "#A4A1B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.74c3655dee00aff400592ab7ffc9aa30.svg";
export { ForwardRef as ReactComponent };